import {
  trigger,
  transition,
  query,
  style,
  group,
  animate,
} from '@angular/animations'

export class RouterAnimations {
  static routeSlide = trigger('routeSlide', [
    transition('* <=> *', [
      group([
        query(
          ':enter',
          [
            style({transform: '{{ enter }}'}),
            animate(
              '0.3s ease-in-out',
              style({transform: 'translateX(0%) translateY(0%)'})
            ),
          ],
          {optional: true}
        ),
        query(
          ':leave',
          [
            style({transform: 'translateX(0%) translateY(0%)'}),
            animate('0.3s ease-in-out', style({transform: '{{ leave }}'})),
          ],
          {optional: true}
        ),
      ]),
    ]),
  ])
}



// WEBPACK FOOTER //
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/animations/animations.ts